<p-toast></p-toast>

<div class="owner-page">
  <header class="owner-header">
    <div>
      <h1>إدارة مالك النظام</h1>
      <p>تحكم بسوبر أدمن لكل نظام واعرض المستخدمين المرتبطين بكل نظام.</p>
    </div>
    <button
      pButton
      icon="pi pi-refresh"
      label="تحديث"
      class="p-button-secondary"
      [loading]="loadingSystems() || loadingDetails()"
      (click)="loadSystems(); loadDetails()"
    ></button>
  </header>

  <div class="owner-layout">
    <aside class="systems-panel">
      <div class="panel-title">الأنظمة</div>

      <button
        type="button"
        class="system-row"
        *ngFor="let system of systems(); trackBy: trackSystem"
        [class.active]="system.key === selectedSystemKey"
        (click)="selectedSystemKey = system.key; loadDetails()"
      >
        <span>
          <strong>{{ system.displayName }}</strong>
          <small>{{ system.key }}</small>
        </span>
        <span class="counts">
          <span>{{ system.superAdminsCount }} سوبر</span>
          <span>{{ system.usersCount }} مستخدم</span>
        </span>
      </button>
    </aside>

    <main class="details-panel" *ngIf="details() as d">
      <section class="summary">
        <div>
          <h2>{{ d.system.displayName }}</h2>
          <p>{{ d.system.key }}</p>
        </div>
        <p-tag
          [value]="d.system.isActive ? 'نشط' : 'معطل'"
          [severity]="d.system.isActive ? 'success' : 'danger'"
        ></p-tag>
      </section>

      <section class="admin-tools">
        <div>
          <h3>سوبر أدمن النظام</h3>
          <p>المستخدم المضاف هنا يحصل على صلاحية كاملة داخل هذا النظام فقط.</p>
        </div>

        <div class="assign-box">
          <p-dropdown
            [options]="candidateOptions()"
            [(ngModel)]="selectedUserId"
            optionLabel="label"
            optionValue="value"
            placeholder="اختر مستخدم"
            appendTo="body"
            [filter]="true"
          ></p-dropdown>
          <button
            pButton
            icon="pi pi-plus"
            label="إضافة"
            [loading]="saving()"
            [disabled]="!selectedUserId"
            (click)="addSuperAdmin()"
          ></button>
        </div>
      </section>

      <p-table
        [value]="d.superAdmins"
        [loading]="loadingDetails()"
        [tableStyle]="{ 'min-width': '46rem' }"
        styleClass="owner-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>المستخدم</th>
            <th>البريد</th>
            <th>الحالة</th>
            <th class="text-end">إجراءات</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td>
              <div class="user-cell">
                <span class="avatar">{{ (user.username?.[0] || 'U') | uppercase }}</span>
                <span>
                  <strong>{{ userLabel(user) }}</strong>
                  <small>{{ '@' + user.username }}</small>
                </span>
              </div>
            </td>
            <td>{{ user.email || '—' }}</td>
            <td>
              <p-tag [value]="statusLabel(user)" [severity]="statusSeverity(user)"></p-tag>
            </td>
            <td class="text-end">
              <button
                pButton
                icon="pi pi-times"
                class="p-button-danger p-button-text"
                pTooltip="إزالة سوبر أدمن"
                [loading]="saving()"
                (click)="removeSuperAdmin(user)"
              ></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="empty">لا يوجد سوبر أدمن لهذا النظام.</td>
          </tr>
        </ng-template>
      </p-table>

      <section class="users-section">
        <div class="section-title">
          <h3>مستخدمو النظام</h3>
          <span>{{ d.users.length }} مستخدم</span>
        </div>

        <p-table
          [value]="d.users"
          [loading]="loadingDetails()"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50]"
          [tableStyle]="{ 'min-width': '58rem' }"
          styleClass="owner-table"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>المستخدم</th>
              <th>البريد</th>
              <th>الأدوار</th>
              <th>الحالة</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <div class="user-cell">
                  <span class="avatar">{{ (user.username?.[0] || 'U') | uppercase }}</span>
                  <span>
                    <strong>{{ userLabel(user) }}</strong>
                    <small>{{ '@' + user.username }}</small>
                  </span>
                </div>
              </td>
              <td>{{ user.email || '—' }}</td>
              <td>
                <span class="role-chip" *ngFor="let role of user.roles">{{ role }}</span>
                <span *ngIf="!user.roles?.length">—</span>
              </td>
              <td>
                <p-tag [value]="statusLabel(user)" [severity]="statusSeverity(user)"></p-tag>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="empty">لا يوجد مستخدمون لهذا النظام.</td>
            </tr>
          </ng-template>
        </p-table>
      </section>
    </main>
  </div>
</div>
